import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { useLocale } from '../context/LocaleContext';

const BadgeLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem;
  border-radius: ${({ theme }) => theme.radiusSm};
  font-size: ${({ theme }) => theme.fontClamp.sm};
  font-weight: 600;
  transition: all 0.2s;
  background: ${({ $active, theme }) => ($active ? theme.colors.maroon : theme.colors.muted)};
  color: ${({ $active, theme }) => ($active ? theme.colors.maroonForeground : theme.colors.foreground)};
  &:hover {
    background: ${({ $active, theme }) => ($active ? theme.colors.maroon : theme.colors.primary)};
    color: ${({ $active, theme }) => ($active ? theme.colors.maroonForeground : theme.colors.primaryForeground)};
  }
`;

const Count = styled.span`
  font-variant-numeric: tabular-nums;
  font-size: ${({ theme }) => theme.fontClamp.xs};
  opacity: ${({ $active }) => ($active ? 0.8 : 1)};
  color: ${({ $active, theme }) => ($active ? 'inherit' : theme.colors.mutedForeground)};
`;

function CategoryBadge({ name, slug, count, active }) {
  const { prependPath } = useLocale();
  const segment = slug || name;
  const to = name === 'All' ? '/categories' : `/categories/${encodeURIComponent(segment)}`;
  return (
    <BadgeLink to={prependPath(to)} $active={active}>
      {name}
      {count !== undefined && <Count $active={active}>{count}</Count>}
    </BadgeLink>
  );
}

export default CategoryBadge;
